"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPaid = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function createPrice(price) {
    if (typeof price === 'string') {
        price = Number(price.replace(',', '.').replace('€', ''));
    }
    if (price === 0 || !price) {
        return 0;
    }
    return price;
}
function labelPrice(price) {
    price = price || 0;
    return price.price('EUR', 'nl-NL');
}
var final_price = '';
var FormPaid = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, toggleVideoOption = _a.toggleVideoOption;
    var _b = react_1.useState(labelPrice(video.options.amount)), price = _b[0], setPrice = _b[1];
    var updatePrice = function (price) {
        setPrice(price);
        final_price = price;
        setTimeout(function () {
            if (final_price === price) {
                setVideo({ options: __assign(__assign({}, video.options), { amount: createPrice(price) }) });
            }
        }, 750);
    };
    react_1.useEffect(function () {
        setPrice(labelPrice(video.options.amount));
    }, [video.options.amount]);
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'flex items-center mb-2' },
            react_1.default.createElement(storybook_1.Forms.Toggle, { value: video.options.enabled, onClick: function () { return toggleVideoOption('enabled'); } }),
            react_1.default.createElement(storybook_1.Texts.Heading, { appendClassname: 'ml-2', type: 'h3' }, "Pay-per-view")),
        react_1.default.createElement(storybook_1.Forms.Input, { type: 'text', className: 'mb-2', value: price, onChange: updatePrice }));
};
exports.FormPaid = FormPaid;
